export const departments = {
	COSTING_DETAILS: { name: "Costing Details", key: "COSTING_DETAILS" },
	// WAREHOUSE_QTY: { name: "WH Qty", key: "WAREHOUSE_QTY" },
};
